import { PhpRoute } from "../enums";

export const providePhpRoute = (route: PhpRoute) => {
    const env = process.env.REACT_APP_ENV === "prod" ? "prod" : "dev";
    const baseUrls = {
        dev: process.env.REACT_APP_PHP_FRONTEND_URL,
        prod: process.env.REACT_APP_PHP_FRONTEND_URL,
    };

    const routes = {
        [PhpRoute.HOME]: "/",
        [PhpRoute.PROFILE]: "/profile",
        [PhpRoute.LOGOUT]: "/user/logout",
    };

    const baseUrl = baseUrls[env];
    const endpoint = routes[route];

    const url = `${baseUrl}${endpoint}`;
    return url;
};
